"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpdateClinicianPaidTo = void 0;
var _utils = require("../../../utils");
var useUpdateClinicianPaidTo = function useUpdateClinicianPaidTo(clinicianId) {
  var _useRequest = (0, _utils.useRequest)((0, _utils.getClinicianProfileUrl)(clinicianId), {
      onError: function onError() {
        _utils.toast.warn({
          title: 'Unable to fetch clinician settings. Please try again.'
        });
      }
    }),
    loadingClinician = _useRequest.loading,
    _useRequest$data = _useRequest.data,
    clinician = _useRequest$data === void 0 ? {} : _useRequest$data,
    refreshClinician = _useRequest.refresh;
  var _useRequest2 = (0, _utils.useRequest)({
      url: (0, _utils.getClinicianProfileUrl)(clinicianId),
      method: 'patch',
      data: {
        paidToByMonument: !clinician.paidToByMonument
      }
    }, {
      manual: true,
      onSuccess: function onSuccess() {
        _utils.toast.success({
          title: 'Clinician settings saved!'
        });
        refreshClinician();
      },
      onError: function onError() {
        _utils.toast.warn({
          title: 'Unable to save settings. Please try again.'
        });
      }
    }),
    updatePaidToByMonument = _useRequest2.run,
    updatingPreferences = _useRequest2.loading;
  var loading = loadingClinician || updatingPreferences;
  return {
    paidTo: clinician.paidToByMonument,
    loading: loading,
    updatePaidToByMonument: updatePaidToByMonument
  };
};
exports.useUpdateClinicianPaidTo = useUpdateClinicianPaidTo;